import { render, staticRenderFns } from "./CompleteProfile.vue?vue&type=template&id=55c09bcc"
import script from "./CompleteProfile.vue?vue&type=script&lang=js"
export * from "./CompleteProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports